module.exports = __webpack_public_path__ + "static/media/W00F0005.bda795b4.svg";